/**
 * How It Works – Landing Page Interactions
 * Handles: scroll animations, sticky nav scroll spy, plan selector, stat counter
 */

(function () {
  'use strict';

  /* ---- Scroll-triggered animations via IntersectionObserver ---- */
  var animateEls = document.querySelectorAll('.animate');

  if (animateEls.length && 'IntersectionObserver' in window) {
    var animObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            animObs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    animateEls.forEach(function (el) {
      animObs.observe(el);
    });
  } else {
    animateEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ---- Animated counter for stat numbers ---- */
  var statNumbers = document.querySelectorAll('.hiw-stats__number[data-count]');

  if (statNumbers.length && 'IntersectionObserver' in window) {
    var counterObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;
          var target = parseInt(el.dataset.count, 10);
          var suffix = el.dataset.suffix || '';
          var duration = 1400;
          var startTime = null;

          function step(now) {
            if (!startTime) startTime = now;
            var elapsed = now - startTime;
            var progress = Math.min(elapsed / duration, 1);
            var ease = 1 - Math.pow(1 - progress, 3);
            var current = Math.round(target * ease);

            if (suffix) {
              el.innerHTML = current + '<span>' + suffix + '</span>';
            } else {
              el.textContent = String(current);
            }

            if (progress < 1) requestAnimationFrame(step);
          }

          requestAnimationFrame(step);
          counterObs.unobserve(el);
        });
      },
      { threshold: 0.5 }
    );

    statNumbers.forEach(function (el) {
      var suffix = el.dataset.suffix || '';
      el.innerHTML = '0' + (suffix ? '<span>' + suffix + '</span>' : '');
      counterObs.observe(el);
    });
  }

  /* ---- Sticky Nav: scroll spy + smooth scroll ---- */
  var stickyNav = document.querySelector('.hiw-sticky-nav');

  if (stickyNav) {
    var links = stickyNav.querySelectorAll('.hiw-sticky-nav__link');
    var navSections = [];

    links.forEach(function (link) {
      var id = link.getAttribute('href');
      if (id && id.startsWith('#')) {
        var target = document.querySelector(id);
        if (target) navSections.push({ link: link, target: target });
      }
    });

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
          e.preventDefault();
          var target = document.querySelector(href);
          if (target) {
            var navHeight = stickyNav.offsetHeight || 60;
            var top =
              target.getBoundingClientRect().top + window.scrollY - navHeight - 16;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollY = window.scrollY;
        var navH = stickyNav.offsetHeight || 60;

        stickyNav.classList.toggle('is-scrolled', scrollY > 20);

        var current = null;
        navSections.forEach(function (item) {
          var rect = item.target.getBoundingClientRect();
          if (rect.top <= navH + 80) current = item.link;
        });

        links.forEach(function (l) {
          l.classList.remove('is-active');
        });
        if (current) current.classList.add('is-active');

        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Plan Selector ---- */
  document.querySelectorAll('.hiw-plans__options').forEach(function (group) {
    var options = group.querySelectorAll('.hiw-plans__option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-checked', 'true');
      });
    });
  });
})();
